import { render, staticRenderFns } from "./ActivityFlowCard.vue?vue&type=template&id=c974b260&"
import script from "./ActivityFlowCard.vue?vue&type=script&lang=js&"
export * from "./ActivityFlowCard.vue?vue&type=script&lang=js&"
import style0 from "./ActivityFlowCard.vue?vue&type=style&index=0&id=c974b260&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports